import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './filtro-pilula.css';

export type FiltroPilulaProps = {
  ligado: boolean;
  aoAlternar: () => void;
  /** Quantos itens este recorte tem. */
  contagem?: number;
  miuda?: boolean;
  children?: ReactNode;
  /* O resto passa adiante — o `title` que explica por que um recorte volta vazio. */
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'children' | 'onClick' | 'type'>;

export function FiltroPilula({
  ligado,
  aoAlternar,
  contagem,
  miuda = false,
  children,
  ...resto
}: FiltroPilulaProps) {
  return (
    <button
      {...resto}
      type="button"
      className={miuda ? 'filtro-pilula filtro-pilula--miuda' : 'filtro-pilula'}
      aria-pressed={ligado}
      onClick={aoAlternar}
    >
      {children}
      {contagem === undefined ? null : <span className="filtro-pilula__contagem">{contagem}</span>}
    </button>
  );
}
